export default __webpack_public_path__ + "4d77a1f0a941c9919a979cf918707815.png";